export function gtmPlatformLinkClicked() {
  const platformLinksInNavbar = document.querySelectorAll('nav a[href^="https://app."]');
  const platformLinksInContent = document.querySelectorAll('main a[href^="https://app."]');
  const platformLinksInFooter = document.querySelectorAll('footer a[href^="https://app."]');

  const platformLinks = {
    menu: platformLinksInNavbar,
    content: platformLinksInContent,
    footer: platformLinksInFooter,
  };

  let ctaIndex = 0;

  for (let section in platformLinks) {
    platformLinks[section].forEach((link) => {
      ctaIndex++;
      const index = ctaIndex;

      link.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click_get_started',
          navigation_position: section,
          navigation_cta_title: link.textContent.trim(),
          index: index,
        });
      });
    });
  }
}

export function gtmFaqLinkClicked() {
  const faqLinks = document.querySelectorAll('nav a[href$="/faq"], footer a[href$="/faq"]');

  faqLinks.forEach((link, index) => {
    link.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'click_faq',
        navigation_position: index == 0 ? 'menu' : 'footer',
      });
    });
  });
}

export function gtmFaqQuestionClicked() {
  const questionLinks = document.querySelectorAll('[data-gtm-nav-question-cat]');

  questionLinks &&
    questionLinks.forEach((link) => {
      link.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click_question',
          navigation_question_category: link.dataset.gtmNavQuestionCat,
          navigation_question_title: link.dataset.gtmNavQuestionTitle,
        });
      });
    });
}

export function gtmMenuLinkClicked() {
  const menuLinks = document.querySelectorAll('nav a');

  menuLinks.forEach((link) => {
    link.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'click_menu_navigation',
        navigation_menu: link.dataset.gtmNavigationMenu.trim(),
      });
    });
  });
}
